<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <v-card>
                            <v-card-title >
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="ask_payoutsa"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="askcancelloading" loading-text="Chargement en cours...">

                                <template v-slot:item.code="{ item }">
                                    <v-chip  dark>{{ item.code }}</v-chip>
                                </template>
                                <template v-slot:item.montant="{ item }">
                                    <v-chip  dark>{{ item.montant +" FCFA" }}</v-chip>
                                </template>
                                <template v-slot:item.pharmacie_slug="{item}">
                                    {{ item.pharmacie_slug.nom}}
                                </template>
                                <template v-slot:item.pharmacie_user_slug="{item}">
                                    {{ item.pharmacie_user_slug.name}}
                                </template>
                                <template v-slot:item.ask_time="{item}">
                                    {{ getformatDate(item.ask_time)}}
                                </template>
                                <template v-slot:item.comment_ask_admin="{item}">
                                    {{ item.comment_ask_admin.substr(0,20)+'...'}}
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                                <template v-slot:item.comment="{item}">
                                    {{ item.comment.substr(0,20)+'...'}}
                                </template>
                                <template  v-slot:item.state_ask="{item}">
                                    <div v-if='item.state_ask==="Annuler"'>
                                        <v-chip color="#bb0b0b" dark>Annuler</v-chip>
                                    </div>
                                    <div v-else-if='item.state_ask==="Retrait éffectué"'>
                                        <v-chip color="green" dark>Approuvé</v-chip>
                                    </div>
                                    <div v-else-if='item.state_ask==="Demande refusée"'>
                                        <v-chip color="red" dark>Refusé</v-chip>

                                    </div>
                                    <div v-else>
                                        <v-select style="width: 100px" v-model="item.state_ask"   :menu-props="{ top: true, offsetY: true }"   :items="items" placeholder="Select..." item-text="state" @change="etatChanged(item)"  ></v-select>

                                    </div>
                                </template>
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="500px">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                    <v-alert v-if="errors" dense outlined
                                                             :type="(errors.update_error)?'error':'success'">
                                                        {{errors.operation}}
                                                    </v-alert>

                                                    <v-text-field v-if="submitting" color="primary" loading
                                                                  disabled></v-text-field>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="12">
                                                            {{editedItem.comment_ask_admin}}
                                                        </v-col>


                                                    </v-row>
                                                </v-form>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="close">Fermer</v-btn>
                                                
                                            </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "Annuler",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                tabs: null,
                dialog: '',
                id: undefined,
                snackbar: false,
                items: [
                    { state: 'Demande refusée', abbr: 'Demande refusée' },
                    { state: 'Retrait éffectué', abbr: 'Retrait éffectué' },
                    { state: 'Demande confirmée, en attente de paiement', abbr: 'Demande confirmée, en attente de paiement' },
                    { state: 'En attente', abbr: 'En attente' },
                    { state: 'Annuler', abbr: 'Annuler  ' },
                ],
                textSnack: '',
                headers: [
                    {text: 'Pharmacie', value: 'pharmacie_slug'},

                    {
                        text: 'Montant',
                        align: 'start',
                        sortable: true,
                        value: 'montant',
                    },
                    {text: 'Numéro de retrait', value: 'phone_receiver'},
                    {text: 'Balance', value: 'balance_now'},
                    {text: 'Demandé par:', value: 'pharmacie_user_slug'},
                    {text: 'Commentaire', value: 'comment'},
                    {text: 'Etat', value: 'state_ask'},
                    {text: 'Message', value: 'comment_ask_admin'},
                    {text: 'Date de demande', value: 'ask_time'},


                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Commentaire requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],


            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle forme" : "Commentaire"
            }
            ,
            ...mapState('ask_payouts/', ['ask_payoutsa','askcancelloading']),

        }

        ,

        mounted() {
            this.$store.dispatch('ask_payouts/getAsk_payoutAnnuler').then(response => {
                window.console.log('ask_payouts', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            etatChanged(item){
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: 'Vous êtes sûr de vouloir changé l\'état de cette démande  ?',
                    confirmButtonText:"Oui",
                    cancelButtonText: "Non",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('ask_payouts/etatAsk_payout', {id:item._id,state_ask:item.state_ask}).then((response) => {
                            console.log('response', response);
                            this.snackbar = true;
                            this.textSnack = response.message;
                            this.submitting = false;
                            if (response.error)
                                this.errors.operation = response.data.message;

                        })
                    }
                    else{
                        this.$store.dispatch('ask_payouts/getAsk_payoutEnattente').then(response => {
                            window.console.log('ask_payouts', response)
                        });
                    }
                })
            },


            editItem(item) {
                this.editedIndex = this.ask_payoutsa.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },
            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('ask_payouts/deleteFormepharmacetique', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.$store.dispatch('ask_payouts/getAsk_payoutEnattente').then(response => {
                    window.console.log('ask_payouts', response)
                });
                this.$refs.form.reset()
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.dialog = false;
            },
            comment(){
                this.submitting = true;
                let data = new FormData();
                data.append("id",this.editedItem._id);
                data.append("comment_ask_admin",this.editedItem.comment_ask_admin);
                console.log(this.editedItem._id)
                this.$store.dispatch('ask_payouts/commentAsk_payout', data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("code", this.editedItem.code);
                data.append("nom", this.editedItem.nom);
                let mineroute = 'ask_payouts/set';
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor(){
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>